var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "2 2 20 20",
    fill: "#1E81F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,8a2,2,0,0,0-2-2H18V4.8A1.37,1.37,0,0,0,18,4.27a.58.58,0,0,0-.22-.22,1.37,1.37,0,0,0-.53,0H14.8a1.37,1.37,0,0,0-.53,0,.58.58,0,0,0-.22.22A1.37,1.37,0,0,0,14,4.8V6H10V4.8A1.37,1.37,0,0,0,10,4.27a.58.58,0,0,0-.22-.22A1.37,1.37,0,0,0,9.2,4H6.8a1.37,1.37,0,0,0-.53,0,.58.58,0,0,0-.22.22A1.37,1.37,0,0,0,6,4.8V6H4A2,2,0,0,0,2,8V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2ZM10.5,14H9v1.5H7V14H5.5V12H7V10.5H9V12h1.5ZM18,14H14V12h4Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.52bfe93b74026b33199318b028d0ebb2.svg";
export { ForwardRef as ReactComponent };